import Text from 'Components/Atoms/Text/Text';
import React, { useEffect, useRef, useState } from 'react';
import { useTable } from 'Services/Table/TableContext';
import styles from './TableColumn.module.sass';

const TableColumn = ({
    children,
    id, size, position, primary,
    ...props
}: Props) => {
    const [offsetLeft, setOffsetLeft] = useState(0);

    const ref = useRef<any>();

    useEffect(() => {
        if (position === 'fixed') {
            setOffsetLeft(ref.current.offsetLeft);
        }
    }, [ref]);

    return <div
        ref={ref}
        className={`
            ${styles['tablecolumn']}
            ${styles['tablecolumn__size--'+(size??'medium')]}
            ${styles['tablecolumn__position--'+(position??'static')]}
            ${styles['tablecolumn__state--'+(primary ? 'primary' : 'static')]}
        `}
        style={{
            left: position === 'fixed' ? offsetLeft : '0'
        }}
    >
        <Text>
            { children }
        </Text>
    </div>;
}

interface Props {
    children?: any
    primary?: boolean
    id?: any
    size?: 'small' | 'medium' | 'large'
    position?: 'fixed' | 'static'
    
}

export default React.memo(TableColumn);